import { useParams, generatePath, NavLink, Outlet } from 'react-router-dom';
import { IconRight, Tabs } from '@ui/src';
import { useAppSelector } from '@store';
import { AccountsStatementsTypes } from './types';

import cn from '../customers.module.css';

const AccountsTransactionStatement = ({
  transactionsPath,
  cardsTransactionsPath,
  title,
  accountsPage,
  accounts,
  cards,
  cardsEnabled,
  balances,
}: AccountsStatementsTypes): React.JSX.Element => {
  const { accountId } = useAppSelector(
    (state) => state.customerAccountsStatements,
  );

  const currentAccount = accounts?.find((item) => item.id === accountId);

  const { customerId } = useParams();

  return (
    <>
      <div className={cn.accountTransactionHistoryTitle}>
        <div className={cn.accountTransactionHistoryTitleLeft}>
          <div className={cn.accountTransactionHistoryTitleText}>
            {title}
            {accountsPage && (
              <NavLink
                className={`${cn.overviewStatementsTitleLink} ${
                  !accountId ? cn.overviewStatementsTitleLinkDisabled : ''
                }`}
                to={`/accounts/statements?account=${currentAccount?.fullNumber}`}
              >
                View all
                <IconRight />
              </NavLink>
            )}
          </div>
        </div>
      </div>
      {cardsEnabled && (
        <div className={cn.accountTransactionTabs}>
          <Tabs
            tabs={[
              {
                name: 'Account transactions',
                path: generatePath(transactionsPath, {
                  customerId,
                }),
              },
              {
                name: 'Card transactions',
                path: generatePath(cardsTransactionsPath, {
                  customerId,
                }),
              },
            ]}
            enableRouting
          />
        </div>
      )}

      <Outlet
        context={{
          accounts,
          cards,
          currentAccount,
          balances,
        }}
      />
    </>
  );
};

export default AccountsTransactionStatement;
